import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ProgressBarBox = styled.div<{
  $percentage: number;
  $type: 'SOH' | 'SOC';
}>`
  width: 100%;
  background-color: #ddd;
  height: 10px;
  overflow: hidden;
  background-color: ${(props) => {
    const { $percentage, $type } = props;
    if ($type === 'SOH') {
      if ($percentage >= 100) return '#b4e2ff'; // 하늘빛
      if ($percentage >= 95) return '#fff7ac'; // 노란빛
      return '#ffdede'; // 붉은빛
    } else if ($type === 'SOC') {
      if ($percentage >= 4) return '#b4e2ff'; // 하늘빛
      return '#ffdede'; // 붉은빛
    }
    return '#ddd';
  }};
`;

const ProgressBarFill = styled.div<{
  $percentage: number;
  $type: 'SOH' | 'SOC';
}>`
  width: ${(props) => props.$percentage}%;
  height: 100%;
  background-color: ${(props) => {
    const { $percentage, $type } = props;
    if ($type === 'SOH') {
      if ($percentage >= 100) return '#00bfff'; // 하늘빛
      if ($percentage >= 95) return '#ffd700'; // 노란빛
      return '#ff6347'; // 붉은빛
    } else if ($type === 'SOC') {
      if ($percentage >= 4) return '#00bfff'; // 하늘빛
      return '#ff6347'; // 붉은빛
    }
    return '#ddd';
  }};
`;

const ProgressBarLabel = styled.div`
  font-size: 12px;
  text-align: center;
`;

interface ProgressBarProps {
  percentage: number; // 숫자 형태로 수정
  type: 'SOH' | 'SOC'; // SOH 또는 SOC를 구분하기 위한 필드
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, type }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarLabel>{`${percentage}%`}</ProgressBarLabel>
      <ProgressBarBox $percentage={percentage} $type={type}>
        <ProgressBarFill $percentage={percentage} $type={type} />
      </ProgressBarBox>
    </ProgressBarContainer>
  );
};

export default ProgressBar;
